import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_p_block_ui = _resolveComponent("p-block-ui")!

  return (_openBlock(), _createBlock(_component_p_block_ui, {
    class: _normalizeClass({ 'app-block-ui-blocked': _ctx.blocked }),
    blocked: _ctx.blocked,
    ref: "pBlockUI"
  }, {
    default: _withCtx(() => [
      (_ctx.blocked)
        ? _renderSlot(_ctx.$slots, "default", { key: 0 })
        : _renderSlot(_ctx.$slots, "default", { key: 1 })
    ]),
    _: 3
  }, 8, ["class", "blocked"]))
}